import { Calculator, Tractor, Home, Briefcase, ArrowRight, Check } from 'lucide-react';
import { services } from '../../mock';

const iconMap = { Calculator, Tractor, Home, Briefcase };

export default function Services() {
  return (
    <section id="services" className="section-anchor py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="brand-divider mb-5" />
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-stone-900 leading-tight">
            Our Services
          </h2>
          <p className="mt-4 text-stone-600 text-[17px] leading-relaxed">
            From end of year accounts and GST to farm scheme calculations and
            cloud accounting setup — we offer practical, personalised solutions
            tailored to your business.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Calculator;
            return (
              <div
                key={s.id}
                className={`service-card group bg-white border border-stone-200 rounded-2xl p-7 md:p-8 fade-up delay-${(i % 4) + 1}`}
              >
                <div className="flex items-start gap-5">
                  <div className="h-14 w-14 rounded-2xl bg-[#0b6b5b] grid place-items-center text-white flex-shrink-0">
                    <Icon className="h-7 w-7" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display font-semibold text-2xl text-stone-900">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-stone-600 leading-relaxed">
                      {s.description}
                    </p>
                    <ul className="mt-5 grid sm:grid-cols-2 gap-x-4 gap-y-2">
                      {s.items.map((item) => (
                        <li key={item} className="flex items-start gap-2 text-sm text-stone-700">
                          <Check className="h-4 w-4 text-[#0b6b5b] mt-0.5 flex-shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <a
                      href="#contact"
                      className="inline-flex items-center gap-1.5 mt-6 text-[#0b6b5b] font-semibold text-sm group-hover:gap-2.5 transition-all"
                    >
                      Enquire about this service
                      <ArrowRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
